import { render, staticRenderFns } from "./CreateMessagePage.vue?vue&type=template&id=49475300&scoped=true"
import script from "./CreateMessagePage.vue?vue&type=script&lang=js"
export * from "./CreateMessagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49475300",
  null
  
)

export default component.exports